//@ts-nocheck
import React, { useEffect, useState } from "react";
import dayjs from "dayjs";
import PageWrapper from "../../../layout/PageWrapper/PageWrapper";
import Button from "../../../components/bootstrap/Button";
import Page from "../../../layout/Page/Page";
import Card, {
  CardActions,
  CardBody,
  CardHeader,
  CardLabel,
  CardTitle,
} from "../../../components/bootstrap/Card";
import PaginationButtons from "../../../components/PaginationButtons";
import ConfirmationModal from "../ConfirmationModal";
import userState from "../../../shared/mobx/user-state";
import Spinner from "../../../components/bootstrap/Spinner";
import Checks from "../../../components/bootstrap/forms/Checks";
import Dropdown, {
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
} from "../../../components/bootstrap/Dropdown";
import LoaderWrapper from "../../../layout/Wrapper/LoaderWrapper";
import AddUserModal from "./AddUserModal";
import SearchBar from "../../../components/SearchBar";
import ascendingIcon from "../../../sorting/ascending-sorting.png"; // Import ascending icon
import descendingIcon from "../../../sorting/descending-sorting.png"; // Import descending icon

const UsersPage = () => {
  const [users, setUsers] = useState<any[]>([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [isLoading, setLoading] = useState(true);
  const [perPage, setPerPage] = useState(10); // Default items per page
  const [totalRecords, setTotalRecords] = useState(0);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [refreshValue, setRefresh] = useState(0);
  const handleOpenModal = () => setIsModalOpen(true);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const handleCloseModal = () => setIsModalOpen(false);
  const [confirmationModal, setConfirmationModal] = useState(false);
  const [verifyModal, setVerifyModal] = useState(false);
  const [user, setUser] = useState<any>({});
  const [searchQuery, setSearchQuery] = useState<string>("");
  const [deleteLoader, setDeleteLoader] = useState(false);
  const [verifyLoader, setVerifyLoader] = useState(false);
  const [sortOrder, setSortOrder] = useState<"asc" | "desc">("desc"); // New state for sorting order
  const [sortField, setSortField] = useState<string>("createdAt"); // New state for sorting field

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [allUsers, setAllUsers] = useState<any[]>([]); // New state to hold all users
  const [filteredData, setFilteredData] = useState<any[]>([]); // New state for filtered data

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const handleAddNew = () => {
    setUser({});
    handleOpenModal();
  };
  const handleUpdateUser = (user) => {
    setUser(user);
    handleOpenModal();
  };

  const refresher = () => {
    setUser({});
    setRefresh(refreshValue + 1);
  };

  const handleSearch = (query: string) => {
    setSearchQuery(query);
    const searchTerms = query.toLowerCase().trim();
    const results = users.filter(
      (user) =>
        user.firstName.toLowerCase().includes(searchTerms) ||
        user.lastName.toLowerCase().includes(searchTerms) ||
        user.email.toLowerCase().includes(searchTerms) ||
        user.package_name.toLowerCase().includes(searchTerms)
    );
    setFilteredData(results);
    setCurrentPage(1); // Reset to the first page on search
  };

  useEffect(() => {

    const fetchData = async () => {
      setLoading(true);
      try {
        const d = await userState.getuserList({
          per_page: perPage, // Use the perPage state for dynamic pagination
          page: currentPage, // Use the currentPage state for pagination
          search: searchQuery, // Use the searchQuery state for searching
          order_by: sortOrder, // Use the sortOrder state for sorting
          order_by_field: sortField, // New parameter for sorting field
        });
        const { total_records } = d;
        setTotalRecords(total_records);
      
        setAllUsers(d?.data || []); // Store all users
        setFilteredData(d?.data || []); // Initialize filtered data
      } catch (error) {
        console.error("Error fetching data:", error); // Log any errors
      } finally {
        setLoading(false);
      }
    };
    fetchData(); // Fetch all users on component mount
  }, [currentPage, perPage, searchQuery, sortOrder, sortField, refreshValue]);

  const setLoader = (item, status = false) => {
    const _u = users?.map((i) =>
      i.id === item.id ? { ...i, loading: status } : i
    );
    setUsers(_u);
  };
  const toggleUserStatus = async (item) => {
    await setLoader(item, true);
    await userState.toggleUserStatus(item);
    await setLoader(item);
    refresher();
  };

  const handleDelete = async (item) => {
    setUser(item);
    setConfirmationModal(true);
  };

  const handleVerify = async (item) => {
    setUser(item);
    setVerifyModal(true);
  };

  const setModalClose = () => {
    setUser({});
    setIsModalOpen(false);
  };

  const deleteAction = async () => {
    setDeleteLoader(true);
    await userState.deleteUser(user.id);
    setUser({});
    setConfirmationModal(false);
    refresher();
    setDeleteLoader(false);
  };

  const verifyAction = async () => {
    setVerifyLoader(true);
    const status = await userState.verifyUser(user);
    if (status) {
      setUser({});
      setVerifyModal(false);
      refresher();
    }
    setVerifyLoader(false);
  };
 

  const toggleSortOrder = (field: string) => {
    if (sortField === field) {
      setSortOrder((prevOrder) => (prevOrder === "asc" ? "desc" : "asc"));
    } else {
      setSortField(field);
      setSortOrder("desc"); // Reset to ascending when changing field
    }
  };

  const sortedData = filteredData.sort((a, b) => {
    const comparison = a[sortField]?.localeCompare(b[sortField]);
    return sortOrder === "asc" ? comparison : -comparison; // Sort based on order
  });

  // const paginatedData = sortedData.slice(
  //   (currentPage - 1) * perPage,
  //   currentPage * perPage
  // ); // Get current page data

  return (
    <PageWrapper title="Users">
      <Page container="fluid">
        <div className="row">
          <div className="col-12">
            <div className="display-6 py-2 plan-heading d-flex justify-content-between align-items-center">
              <span>Users</span>
              <CardActions>
                <Button onClick={handleOpenModal} color="info auth-btn">
                  Add New User
                </Button>
              </CardActions>
            </div>
          </div>
          <div className="col-12">
            <Card>
              <CardHeader borderSize={1}>
                <CardLabel iconColor="info">
                  <CardTitle tag="div" className="h5">
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        width: "100%",
                        gap: "90.5rem",
                      }}
                    >
                      <span className="fw-bold fs-4">Users</span>
                      <div className="d-flex justify-content-end">
                        <SearchBar
                          fetchData={() => {}}
                          placeholder="Search User"
                          onSearch={handleSearch}
                        />
                      </div>
                    </div>
                  </CardTitle>
                </CardLabel>
              </CardHeader>
              <CardBody className="table-responsive">
                <LoaderWrapper isLoading={isLoading} data={sortedData}>
                  <>
                    <table className="table table-modern">
                      <thead>
                        <tr>
                          <th onClick={() => toggleSortOrder("firstName")}>
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                cursor: "pointer",
                              }}
                            >
                              First Name
                              {sortField === "firstName" &&
                                (sortOrder === "asc" ? (
                                  <img
                                    src={ascendingIcon}
                                    alt="Ascending"
                                    style={{
                                      marginLeft: "5px",
                                      verticalAlign: "middle",
                                      cursor: "pointer",
                                      width: "16px",
                                      height: "16px",
                                    }}
                                  />
                                ) : (
                                  <img
                                    src={descendingIcon}
                                    alt="Descending"
                                    style={{
                                      marginLeft: "5px",
                                      verticalAlign: "middle",
                                      cursor: "pointer",
                                      width: "16px",
                                      height: "16px",
                                    }}
                                  />
                                ))}
                            </div>
                          </th>
                          <th onClick={() => toggleSortOrder("lastName")}>
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                cursor: "pointer",
                              }}
                            >
                              Last Name
                              {sortField === "lastName" &&
                                (sortOrder === "asc" ? (
                                  <img
                                    src={ascendingIcon}
                                    alt="Ascending"
                                    style={{
                                      marginLeft: "5px",
                                      verticalAlign: "middle",
                                      cursor: "pointer",
                                      width: "16px",
                                      height: "16px",
                                    }}
                                  />
                                ) : (
                                  <img
                                    src={descendingIcon}
                                    alt="Descending"
                                    style={{
                                      marginLeft: "5px",
                                      verticalAlign: "middle",
                                      cursor: "pointer",
                                      width: "16px",
                                      height: "16px",
                                    }}
                                  />
                                ))}
                            </div>
                          </th>
                          <th onClick={() => toggleSortOrder("email")}>
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                cursor: "pointer",
                              }}
                            >
                              Email
                              {sortField === "email" &&
                                (sortOrder === "asc" ? (
                                  <img
                                    src={ascendingIcon}
                                    alt="Ascending"
                                    style={{
                                      marginLeft: "5px",
                                      verticalAlign: "middle",
                                      cursor: "pointer",
                                      width: "16px",
                                      height: "16px",
                                    }}
                                  />
                                ) : (
                                  <img
                                    src={descendingIcon}
                                    alt="Descending"
                                    style={{
                                      marginLeft: "5px",
                                      verticalAlign: "middle",
                                      cursor: "pointer",
                                      width: "16px",
                                      height: "16px",
                                    }}
                                  />
                                ))}
                            </div>
                          </th>
                          <th onClick={() => toggleSortOrder("package_name")}>
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                cursor: "pointer",
                              }}
                            >
                              Package Name
                              {sortField === "package_name" &&
                                (sortOrder === "asc" ? (
                                  <img
                                    src={ascendingIcon}
                                    alt="Ascending"
                                    style={{
                                      marginLeft: "5px",
                                      verticalAlign: "middle",
                                      cursor: "pointer",
                                      width: "16px",
                                      height: "16px",
                                    }}
                                  />
                                ) : (
                                  <img
                                    src={descendingIcon}
                                    alt="Descending"
                                    style={{
                                      marginLeft: "5px",
                                      verticalAlign: "middle",
                                      cursor: "pointer",
                                      width: "16px",
                                      height: "16px",
                                    }}
                                  />
                                ))}
                            </div>
                          </th>
                          {/* <th>Creation Date</th> */}
                          <th onClick={() => toggleSortOrder("createdAt")}>
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                cursor: "pointer",
                              }}
                            >
                              Creation Date
                              {sortField === "createdAt" &&
                                (sortOrder === "asc" ? (
                                  <img
                                    src={ascendingIcon}
                                    alt="Ascending"
                                    style={{
                                      marginLeft: "5px",
                                      verticalAlign: "middle",
                                      cursor: "pointer",
                                      width: "16px",
                                      height: "16px",
                                    }}
                                  />
                                ) : (
                                  <img
                                    src={descendingIcon}
                                    alt="Descending"
                                    style={{
                                      marginLeft: "5px",
                                      verticalAlign: "middle",
                                      cursor: "pointer",
                                      width: "16px",
                                      height: "16px",
                                    }}
                                  />
                                ))}
                            </div>
                          </th>


                          <th>Role</th>
                          <th>Status</th>
                          <th>Verification</th>
                          <th>Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {sortedData.length > 0 ? (
                          sortedData.map((item) => (
                            <tr key={item.id}>
                              <td>{item.firstName}</td>
                              <td>{item.lastName}</td>
                              <td>{item.email}</td>
                              <td>{item.package_name || "N/A"}</td>
                              <td>
                                {dayjs(item.createdAt).format("MM-DD-YYYY")}
                              </td>
                              <td>{item.role.name}</td>
                              <td>
                                {item.loading ? (
                                  <>
                                    <Spinner size="12px" color="primary" />
                                  </>
                                ) : (
                                  <Checks
                                    id="status"
                                    name="usageStatus"
                                    className="status"
                                    type="switch"
                                    onChange={() => toggleUserStatus(item)}
                                    checked={item.status === "Active"}
                                  />
                                )}
                              </td>
                              <td>
                                {item.emailVerifiedAt ? (
                                  <span style={{ color: '#28a745', fontWeight: 'bold' }}>Verified</span>
                                ) : (
                                  <Button
                                    color="success"
                                    size="sm"
                                    onClick={() => handleVerify(item)}
                                    disabled={item.loading}
                                  >
                                    Verify
                                  </Button>
                                )}
                              </td>
                              <td>
                                <Dropdown>
                                  <DropdownToggle hasIcon={false}>
                                    <Button
                                      icon="MoreHoriz"
                                      aria-label="More options"
                                    />
                                  </DropdownToggle>
                                  <DropdownMenu isAlignmentEnd>
                                    <DropdownItem>
                                      <Button
                                        tag="a"
                                        to={`/users/details/${item.id}`}
                                        icon="Details"
                                      >
                                        View Subscriptions
                                      </Button>
                                    </DropdownItem>
                                    <DropdownItem>
                                      <Button
                                        tag="a"
                                        to={`/api-key-management/${item.id}`}
                                        icon="Details"
                                      >
                                        Api key management
                                      </Button>
                                    </DropdownItem>
                                    <DropdownItem>
                                      <Button
                                        onClick={() => handleUpdateUser(item)}
                                        icon="Edit"
                                      >
                                        Edit
                                      </Button>
                                    </DropdownItem>
                                    <DropdownItem>
                                      <Button
                                        onClick={() => handleDelete(item)}
                                        icon="Delete"
                                      >
                                        Delete
                                      </Button>
                                    </DropdownItem>
                                  </DropdownMenu>
                                </Dropdown>
                              </td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td colSpan={9} className="text-center">
                              No data available
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>

                    <PaginationButtons
                      data={filteredData}
                      label="users"
                      setCurrentPage={setCurrentPage}
                    
                      currentPage={currentPage}
                      perPage={perPage}
                      setPerPage={setPerPage}
                      totalItems={totalRecords} // Use totalRecords for pagination
                    />
                  </>
                </LoaderWrapper>
              </CardBody>
            </Card>
          </div>
        </div>
      </Page>
      {isModalOpen ? (
        <AddUserModal
          refresher={refresher}
          user={user}
          isOpen={isModalOpen}
          onClose={setModalClose}
        />
      ) : null}
      <ConfirmationModal
        isOpen={confirmationModal}
        setIsOpen={setConfirmationModal}
        loading={deleteLoader}
        title="Confirmation?"
        message="Are you sure you want to delete the user?"
        handleAction={deleteAction}
      />
      <ConfirmationModal
        isOpen={verifyModal}
        setIsOpen={setVerifyModal}
        loading={verifyLoader}
        title="Verify and Activate User Account?"
        message={`Are you sure you want to verify and activate ${user.firstName} ${user.lastName}'s account? The account will be verified, activated, and a confirmation email will be sent to ${user.email}.`}
        handleAction={verifyAction}
      />
    </PageWrapper>
  );
};

export default UsersPage;
